import { useMinicartRecommendations } from "../../hooks/use-minicart-recommendations";
import { MMUpsellProductList } from "../features/upsell/MMUpsellProductList";

export const MMMinicartUpsellSkeleton = () => {
  return (
    <div
      className="flex animate-pulse flex-col gap-4 bg-surface-2 px-4 py-6"
      aria-hidden="true"
    >
      <div className="flex flex-col items-center gap-2">
        <div className="h-5 w-48 rounded-full bg-neutral-200" />
      </div>
      <div className="flex gap-4 overflow-hidden">
        {Array.from({ length: 2 }).map((_, index) => (
          <div
            key={index}
            className="flex h-36 w-[310px] shrink-0 gap-4 rounded bg-white p-4"
          >
            <div className="h-28 w-[84px] shrink-0 rounded bg-neutral-200" />
            <div className="flex flex-1 flex-col justify-between">
              <div className="flex flex-col gap-1.5">
                <div className="h-4 w-3/4 rounded-full bg-neutral-200" />
                <div className="h-4 w-1/3 rounded-full bg-neutral-200" />
              </div>
              <div className="h-10 w-full rounded bg-neutral-200" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const MMMinicartUpsell = () => {
  const { recommendations, loading } = useMinicartRecommendations("standard");

  if (!recommendations.length) {
    if (loading) return <MMMinicartUpsellSkeleton />;
    return null;
  }

  return (
    <MMUpsellProductList
      products={recommendations}
      heading="Mini_Cart_Recommendations_Heading"
      context="minicart"
    />
  );
};
